import React, { useEffect, useRef, useState } from 'react';
import { Fireworks } from '@fireworks-js/react';
import { useSpring, animated, AnimatedProps } from '@react-spring/web';
import dogs from '../img/dogs.png';

const FinalSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const [sectionTop, setSectionTop] = useState(0);
  const [sectionHeight, setSectionHeight] = useState(0);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const titleAnimation = useSpring({
    transform: `translateY(${Math.max(70 - (scrollY - sectionTop), 0)}px)`,
    config: { tension: 80, friction: 20 },
  });

  useEffect(() => {
    const handleResize = () => {
      if (sectionRef.current) {
        setSectionTop(sectionRef.current.offsetTop);
        setSectionHeight(sectionRef.current.offsetHeight);
      }
    };

    const handleScroll = () => {
      const viewportBottom = window.innerHeight + window.scrollY;
      const tolerance = 50;

      // Check if the bottom of the viewport has reached the section
      if (viewportBottom + tolerance >= sectionTop + sectionHeight) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }

      setScrollY(window.scrollY);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [sectionTop, sectionHeight]);

  const AnimatedTitle = animated.h2 as React.FC<
    AnimatedProps<React.HTMLAttributes<HTMLDivElement>>
  >;

  return (
    <section
      ref={sectionRef}
      className={'relative h-screen text-center overflow-hidden'}
    >
      {isAtBottom && (
        <Fireworks
          options={{
            rocketsPoint: { min: 20, max: 40 },
          }}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '60%',
            zIndex: 1,
          }}
        />
      )}
      <AnimatedTitle
        style={titleAnimation}
        className="text-5xl lg:text-6xl text-[#070707] font-cormorant tracking-wider uppercase"
      >
        GETSEMANI Y RODRIGO
      </AnimatedTitle>
      <div className="absolute bottom-0 left-0 w-full flex justify-center">
        <img
          src={dogs}
          alt="Dogs"
          className="h-auto max-h-[400px] object-contain"
        />
      </div>
    </section>
  );
};

export default FinalSection;
